import { frozen } from "mobx-keystone";
import {
  EACH_CLOSURE_MIGHT_COST,
  LOWEST_POSSIBLE_ONCHAIN_FEE_SATS,
} from "../../helpers/constants";
import { Cubby } from "../Cubby";

export const sixConfirmationEstimateOrNull = (cubby: Cubby) => {
  return (
    cubby.lastOnchainFeeEstimates?.data?.find(
      (estimate) => estimate.confirmations === 6
    ) ?? null
  );
};

export const safeEstimatedOnchainFee = (cubby: Cubby) => {
  const estimate = sixConfirmationEstimateOrNull(cubby);
  return estimate?.fee || LOWEST_POSSIBLE_ONCHAIN_FEE_SATS;
};

export const safeEstimatedClosureCost = (cubby: Cubby) => {
  const estimate = sixConfirmationEstimateOrNull(cubby);
  const unsafeComputed = estimate?.fee || EACH_CLOSURE_MIGHT_COST;
  const safeEstimated = Math.max(unsafeComputed, EACH_CLOSURE_MIGHT_COST);
  return safeEstimated;
};

export const getFeeEstimateForArbitrarySatoshisAmount = (
  cubby: Cubby,
  amountInSatoshis: number
) => {
  let destinationAddress = null;
  console.log(
    "getting fee estimate for arbitrary satoshis amount",
    amountInSatoshis
  );

  if (cubby.cubbyNetwork === "mainnet") {
    destinationAddress =
      "bc1p5gdajugdmu4j8k7hkzn5hel9z5gf7tq42x8pl9rdep6t02v8mcuskekk6r";
  } else if (cubby.cubbyNetwork === "testnet") {
    destinationAddress =
      "tb1pryc3tngw5tjd22q5srqpf86vg7m2q2h2vmhagmq2ptrjdhplzj2stkymf3";
  }

  if (destinationAddress) {
    getFeeEstimate(cubby, amountInSatoshis, destinationAddress);
  }
};

export const getFeeEstimate = (
  cubby: Cubby,
  amountInSatoshis: number,
  destinationAddress: string
) => {
  cubby.resetLastOnchainFeeEstimates();
  cubby.lastProposedSatoshiSendAmount = amountInSatoshis;

  // Clear the previous timeout if it exists
  if (cubby.feeEstimateTimeoutId) {
    clearTimeout(cubby.feeEstimateTimeoutId);
  }

  // Set a new timeout to debounce the fee estimate request
  cubby.feeEstimateTimeoutId = setTimeout(() => {
    cubby.lastGotFeeEstimate = Date.now();
    cubby.cubbyLife("get_fee_estimate", {
      amountInSatoshis: amountInSatoshis,
      destinationAddress: destinationAddress,
    });
  }, 200); // Adjust the debounce delay as needed (200ms in this case)
};

export const handleOnchainFeeEstimateResponse = (
  cubby: Cubby,
  amountInSatoshis: number,
  feesInSatoshis: any[]
) => {
  // console.log("in handleOnchainFeeEstimateResponse");
  if (amountInSatoshis !== cubby.lastProposedSatoshiSendAmount) {
    console.log("got a fee estimate for an old amount, ignoring");
    return;
  }
  console.log("setting last onchain fee estimate");
  cubby.lastOnchainFeeEstimates = frozen(feesInSatoshis);
  // console.log("lastOnchainFeeEstimates", cubby.lastOnchainFeeEstimates.data);
};
